var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZeddlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    y: 0.5,
    width: 28,
    height: 28,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79094 16.1001L9.08845 13.9054L8.87473 13.8241H8.85692C8.78568 13.7834 7.48554 13.2754 7.48554 13.2754C4.17284 12.3 4.11941 6.32534 8.03765 5.16699H19.7746C23.6216 5.57343 24.6011 9.75973 21.4665 12.9503C20.5404 13.8647 19.4896 14.7183 18.795 15.3685C20.5938 16.0798 23.1941 16.4659 22.9982 20.2051C22.8913 22.1967 21.8405 23.5176 20.5404 23.7615L9.10626 23.7818C4.83182 24.3914 2.85489 19.4939 6.79094 16.1001ZM10.8339 12.239L15.9098 7.40239H8.05546C5.34832 10.1052 8.57196 12.0561 10.8339 12.239ZM16.9784 16.9943C15.2508 18.5794 13.3629 20.2864 11.8668 21.6074L20.3979 21.4854C21.6981 21.2009 21.7337 18.9452 20.8254 18.5388C19.5608 17.9901 18.2607 17.5023 16.9784 16.9943ZM9.12407 21.5057L20.5582 10.2474C21.8227 8.90621 19.6677 6.46759 18.3497 7.76819L7.14714 18.4575C5.50861 20.4693 7.78831 22.7251 9.12407 21.5057Z",
    fill: "#007DE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeddlogo);
export default __webpack_public_path__ + "static/media/zeddlogo.c3b6054d606160acb5382f9411dca69b.svg";
export { ForwardRef as ReactComponent };